module.exports = __webpack_public_path__ + "media/promo/advent/images/cells/cell-27-64dacfd41bbb6d9f54bb99ee4ac2ab4d.png";